export type AppLink = {
  icon: string
  color: string
  title: string
  subtext: string
  href: string
}

export type SearchSuggestion = {
  title: string
  subtext: string
  href: string
}

export type LanguageOption = {
  code: string
  label: string
  subtext: string
  flagIcon: string
}

const MANAGER_SETTINGS_HREF = '/manager/settings'

export const appLinks: AppLink[] = [
  {
    icon: 'solar:chart-3-line-duotone',
    color: 'primary',
    title: 'Tableau de bord',
    subtext: 'Vue centrale des réservations',
    href: '/manager/dashboard',
  },
  {
    icon: 'solar:water-rising-line-duotone',
    color: 'info',
    title: 'Lacs',
    subtext: 'Gestion des plans d’eau',
    href: '/manager/lakes',
  },
  {
    icon: 'solar:calendar-check-line-duotone',
    color: 'success',
    title: 'Réservations',
    subtext: 'Suivi et paiements',
    href: '/manager/reservations',
  },
  {
    icon: 'solar:qr-code-line-duotone',
    color: 'warning',
    title: 'Check-in',
    subtext: 'Scanner les QR codes',
    href: '/manager/checkin/scan',
  },
  {
    icon: 'solar:settings-2-line-duotone',
    color: 'secondary',
    title: 'Paramètres',
    subtext: 'Préférences organisation',
    href: MANAGER_SETTINGS_HREF,
  },
  {
    icon: 'solar:shopping-bag-line-duotone',
    color: 'warning',
    title: 'Marketplace',
    subtext: 'Explorer les lacs partenaires',
    href: '/lacs',
  },
  {
    icon: 'solar:user-group-line-duotone',
    color: 'error',
    title: 'Équipe',
    subtext: 'Inviter et suivre',
    href: '/manager/team',
  },
  {
    icon: 'solar:chart-square-line-duotone',
    color: 'secondary',
    title: 'Performance',
    subtext: 'Indicateurs et analyses',
    href: '/manager/performance',
  },
  {
    icon: 'solar:bookmark-line-duotone',
    color: 'info',
    title: 'Préférences',
    subtext: 'Raccourcis et accès',
    href: MANAGER_SETTINGS_HREF,
  },
]

export const searchSuggestions: SearchSuggestion[] = [
  {
    title: 'Tableau de bord manager',
    subtext: 'Vue générale des indicateurs',
    href: '/manager/dashboard',
  },
  {
    title: 'Réservations',
    subtext: 'Historique et paiement',
    href: '/manager/reservations',
  },
  {
    title: 'Check-in Scanner',
    subtext: 'Générer et vérifier les QR codes',
    href: '/manager/checkin/scan',
  },
  {
    title: 'Lacs',
    subtext: 'Gérer vos lacs et spots',
    href: '/manager/lakes',
  },
  {
    title: 'Équipe',
    subtext: 'Ajouter ou modifier des membres',
    href: '/manager/team',
  },
  {
    title: 'Préférences',
    subtext: 'Paramètres organisation',
    href: MANAGER_SETTINGS_HREF,
  },
  {
    title: 'Performance',
    subtext: 'Indicateurs et analyses',
    href: '/manager/performance',
  },
  {
    title: 'Public site',
    subtext: 'Consulter la boutique publique',
    href: '/',
  },
]

export const languageOptions: LanguageOption[] = [
  {
    code: 'fr',
    label: 'Français',
    subtext: 'French',
    flagIcon: 'twemoji:flag-france',
  },
  {
    code: 'en',
    label: 'English (US)',
    subtext: 'English',
    flagIcon: 'twemoji:flag-united-states',
  },
  {
    code: 'de',
    label: 'Deutsch',
    subtext: 'German',
    flagIcon: 'twemoji:flag-germany',
  },
  {
    code: 'es',
    label: 'Español',
    subtext: 'Spanish',
    flagIcon: 'twemoji:flag-spain',
  },
  {
    code: 'nl',
    label: 'Nederlands',
    subtext: 'Dutch',
    flagIcon: 'twemoji:flag-netherlands',
  },
]
